import { AloAddress, getDefaultAloAddress } from './AloAddress';
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMedia, getDefaultAloMedia } from './AloMedia';
import { AloPageContent, getDefaultAloPageContent } from './AloPageContent';


export interface AloTemplateHoraire extends AloBase {      
    usrId:number    
    acyIdCplt:number    
    thrHeure:number
    thrMinute:number
    thrJour:number
    tcsId:number
}

export const getDefaultAloTemplateHoraire = (jour:number=3,heure:number=14,minute:number=0):AloTemplateHoraire => {
    return {  
        ...getDefaultAloBase(),        
        usrId:2, //LOIC
        acyIdCplt:0,
        thrHeure:heure,
        thrMinute:minute,
        thrJour:jour,
        tcsId:0
    }
}

export const cleanAloTemplateHoraire = (tplHoraire:AloTemplateHoraire) => {
    if(!tplHoraire) return    
    if(!tplHoraire.id) delete tplHoraire.id
    if(!tplHoraire.usrId) delete tplHoraire.usrId
    if(!tplHoraire.acyIdCplt) delete tplHoraire.acyIdCplt
    if(!tplHoraire.tcsId) delete tplHoraire.tcsId
    
}